import { useMemo } from 'react';
import debounce from 'lodash/debounce';
import TranslationText from '@Components/Utilities/TranslationText';
import { listResultsPerPageOptions, gridResultsPerPageOptions } from '@Components/Utilities/SandhillsConstants';

const ResultsDropdown = (props) => {

    const delayQuery = useMemo(() => debounce(e => props.OnChange(e), 500), []);

    const changeResultsPerPage = (e) => {
        let result = parseInt(e.target ? e.target.value : e);
        delayQuery(result);
    };
    

    return (
        <div className="list-results-dropdown">
            <div className="results-dropdown-container">
                <label htmlFor={"results-per-page" + (props.location ? "-" + props.location : "")}>
                    <strong><TranslationText tKey="sandhills.results" />:</strong>
                </label>
                &nbsp;
                <select className="list-results-select" id={"results-per-page" + (props.location ? "-" + props.location : "")} value={props.SelectedValue} onChange={changeResultsPerPage}>
                    {(props.UseNewListPageDesign ? gridResultsPerPageOptions : listResultsPerPageOptions).map(num => <option value={num}>{num}</option>)}
                </select>
            </div>
        </div>
    );
};

export default ResultsDropdown;